import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export default api;

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await axios.post(`${API}/uploads`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
